module.exports = __webpack_public_path__ + "static/media/ARTICLES.42aaa7f0.png";